import React, { PureComponent } from 'react'
import cn from 'classnames'
import PropTypes from 'prop-types'
import { renderChildren } from '../children'
import { PROP_TYPE_CHILDREN } from '../constants'

interface AnimationHandlerProps {
  animating?: boolean
  important?: boolean
  children: React.ReactElement | React.ReactElement[]
  type?:
    | 'zoom'
    | 'ken-burns'
    | 'lift'
    | 'zoom-tile'
    | 'show'
    | 'show-delayed'
    | 'hide'
    | 'hide-delayed'
}

export default class AnimationHandler extends PureComponent<AnimationHandlerProps> {
  static propTypes = {
    animating: PropTypes.bool,
    children: PROP_TYPE_CHILDREN.isRequired,
    important: PropTypes.bool,
    type: PropTypes.oneOf([
      'zoom',
      'ken-burns',
      'lift',
      'zoom-tile',
      'show',
      'show-delayed',
      'hide',
      'hide-delayed',
    ]),
  }

  static defaultProps = {
    type: 'zoom',
  }

  render() {
    const { animating, children, important, type, ...restProps } = this.props

    const classes = cn({
      'mc-animation': true,
      [`mc-animation--${type}`]: type,
      'mc-animation--animating': animating,
      'mc-animation--important': important,
    })

    return renderChildren(children, {
      className: classes,
      ...restProps,
    })
  }
}
